import React, { useState, useEffect }  from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';

import Loading from 'app/components/loaders/Loading';

import Step1 from 'app/components/accounting/stripe/Step1';
import Step2 from 'app/components/accounting/stripe/Step2';
import Step3 from 'app/components/accounting/stripe/Step3';
import Step4 from 'app/components/accounting/stripe/Step4';

import { paper } from 'app/styles/core';
import { container } from 'app/styles/new-layout';

import useApi from 'app/context/useApi';

const useStyles = makeStyles(theme => ({
    paper: {
        ...paper(theme),
        position: 'relative'
    },
    container: {
        ...container(theme),
        padding: theme.spacing(3)
    },
    section: {
        marginBottom: theme.spacing(3)
    },
    stepper: {
        backgroundColor: 'transparent'
    }
}));

const stripePromise = loadStripe(process.env.MIX_STRIPE_KEY);

export default function StripeOnboarding(props) {

    const classes = useStyles();

    const [ stripeClub, setStripeClub ] = useState(null);
    const [ activeStep, setActiveStep ] = useState(0);

    const [ loading, setLoading ] = useState(false);

    const api = useApi();

    const getStripeClub = () => {

        setLoading(true);

        api.get('/admin/accounting/stripe')
            .then(res => setStripeClub(res.club))
            .catch(error => {/*console.log(error)*/})
            .then(() => setLoading(false));
    }

    useEffect(() => {
        getStripeClub();
    }, [])

    useEffect(() => {
        if (stripeClub) {
            if (stripeClub.stripe_account.external_accounts.total_count > 0) {
                setActiveStep(3);
            } else if (stripeClub.stripe_representative_account.verification.document.front) {
                setActiveStep(2);
            } else {
                setActiveStep(1);
            }
        }
    }, [stripeClub])

    return (
        <Elements stripe={stripePromise}>
            <div className={classes.container}>
                <Grid container justify="space-between" align="center" className={classes.section}>
                    <Grid item>
                        <Typography variant="h4" component="h2">
                            Start Accepting Payments
                        </Typography>
                    </Grid>
                    <Grid item>

                    </Grid>
                </Grid>
                <Stepper activeStep={activeStep} className={classes.stepper}>
                    <Step>
                        <StepLabel>Account Setup</StepLabel>
                    </Step>
                    <Step>
                        <StepLabel>Verify Your Identity</StepLabel>
                    </Step>
                    <Step>
                        <StepLabel>Connect Your Bank</StepLabel>
                    </Step>
                    <Step>
                        <StepLabel>Completed</StepLabel>
                    </Step>
            </Stepper>
                <Paper className={classes.paper}>
                    <Loading isLoading={loading}/>
                    {activeStep == 0 &&
                        <Step1 setLoading={setLoading} refreshClub={getStripeClub}/>
                    }
                    {activeStep == 1 &&
                        <Step2 stripeClub={stripeClub} setLoading={setLoading} refreshClub={getStripeClub}/>
                    }
                    {activeStep == 2 &&
                        <Step3 stripeClub={stripeClub} setLoading={setLoading} refreshClub={getStripeClub}/>
                    }
                    {activeStep == 3 &&
                        <Step4 stripeClub={stripeClub} setLoading={setLoading} refreshClub={getStripeClub}/>
                    }
                </Paper>
            </div>
        </Elements>

    )
}
